export const hasPackagingOptions = (product) =>
    Array.isArray(product?.packaging_options) && product.packaging_options.length > 0;

export const hasCityValues = (opts) => {
    if (!Array.isArray(opts)) return false;
    return opts.some(o => o.city && o.city.trim() !== '');
};

export const getUniquePackagings = (opts) => {
    if (!Array.isArray(opts)) return [];
    return [...new Set(opts.map(o => o.packaging).filter(Boolean))];
};

export const getCitiesForPackaging = (opts, packaging) => {
    if (!Array.isArray(opts) || !packaging) return [];
    return [...new Set(
        opts.filter(o => o.packaging === packaging)
            .map(o => o.city)
            .filter(Boolean)
    )];
};

export const findOption = (opts, packaging, city) => {
    if (!Array.isArray(opts)) return null;
    if (city) {
        return opts.find(o => o.packaging === packaging && o.city === city) || null;
    }
    return opts.find(o => o.packaging === packaging) || null;
};

const ATTR_LABELS = {
    'pa_package-type': 'Выберите упаковку',
    'pa_warehouse': 'Выберите склад отгрузки',
    'pa_sizeof': 'Выберите размер',
    'pa_color': 'Выберите цвет',
    'pa_vet': 'Выберите специалиста',
    'pa_pcr': 'Выберите тип исследования',
};

export const getSelectLabels = (product) => {
    const rawAttrs = product?.attributes;
    const attrs = (Array.isArray(rawAttrs) ? rawAttrs : []).filter(a => a.variation);
    if (attrs.length === 0) return { firstLabel: 'Выберите вариант', secondLabel: '' };

    const firstLabel = ATTR_LABELS[attrs[0].slug] || `Выберите ${attrs[0].name.toLowerCase()}`;

    const remaining = attrs.slice(1);
    let secondLabel = '';
    if (remaining.length === 1) {
        secondLabel = ATTR_LABELS[remaining[0].slug] || `Выберите ${remaining[0].name.toLowerCase()}`;
    } else if (remaining.length > 1) {
        secondLabel = 'Выберите вариант';
    }

    return { firstLabel, secondLabel };
};

export const isFirstSelectSearchable = (product) => {
    const rawAttrs = product?.attributes;
    const attrs = (Array.isArray(rawAttrs) ? rawAttrs : []).filter(a => a.variation);
    return attrs.length > 0 && attrs[0].slug === 'pa_warehouse';
};